@if (collapsed()) {
  <button
    #pickerTrigger
    type="button"
    pRipple
    class="sidebar-icon-button app-button-motion-self app-button-motion-self-solid app-button-motion-trigger motion-safe-transition"
    [pTooltip]="collapsedTooltip()"
    tooltipPosition="right"
    aria-label="Wybierz zestaw kolorów"
    (click)="pickerPopover.toggle($event, pickerTrigger)"
  >
    <div class="sidebar-nav-icon motion-safe-transition">
      <app-sidebar-icon icon="pi pi-palette" class="sidebar-nav-icon-glyph" />
    </div>
  </button>
} @else {
  <button
    #pickerTrigger
    type="button"
    pRipple
    class="sidebar-theme-trigger motion-safe-transition"
    aria-label="Wybierz zestaw kolorów"
    (click)="pickerPopover.toggle($event, pickerTrigger)"
  >
    <div class="sidebar-theme-trigger-leading">
      <div class="sidebar-nav-icon sidebar-nav-icon-active motion-safe-transition">
        <app-sidebar-icon icon="pi pi-palette" class="sidebar-nav-icon-glyph sidebar-nav-icon-glyph-active" />
      </div>

      <div class="sidebar-theme-trigger-copy">
        <span class="sidebar-theme-trigger-title">Kolor akcentu</span>
        <span class="sidebar-theme-trigger-value">{{ selectedTheme().label }}</span>
      </div>
    </div>

    <div class="sidebar-theme-trigger-preview" aria-hidden="true">
      @for (stop of previewStops; track stop) {
        <span
          class="sidebar-theme-preview-dot"
          [style.background]="selectedTheme().themes.light.primary[stop]"
        ></span>
      }
    </div>
  </button>
}

<p-popover
  #pickerPopover
  [appendTo]="'body'"
  [style]="{ width: collapsed() ? '19rem' : '22rem' }"
  ariaLabel="Wybór zestawu kolorów"
>
  <div class="sidebar-theme-popover">
    <div class="sidebar-theme-popover-header">
      <div>
        <h3 class="sidebar-theme-popover-title">Motyw koloru akcentu</h3>
      </div>
      <p class="sidebar-theme-popover-caption">
        Wybierz swój ulubiony zestaw kolorystyczny spośród 3 dostępnych kategorii
      </p>
    </div>

    <p-select
      [ngModel]="selectedFamilyOption()"
      [options]="themeFamilies"
      optionLabel="label"
      [appendTo]="'body'"
      panelStyleClass="sidebar-theme-family-select-panel"
      ariaLabel="Rodzina motywów"
      class="sidebar-theme-family-select"
      placeholder="Wybierz rodzinę motywów"
      (onChange)="onFamilySelectionChange($event)"
    >
      <ng-template let-family pTemplate="item">
        <div class="sidebar-theme-family-option">
          <span class="sidebar-theme-family-option-label">{{ family.label }}</span>
          <span class="sidebar-theme-family-option-count">{{ family.themesCount }}</span>
        </div>
      </ng-template>
    </p-select>

    <div class="sidebar-theme-grid">
      @for (theme of themesByFamily[activeFamily()]; track theme.id) {
        <button
          type="button"
          class="sidebar-theme-card motion-safe-transition"
          [class.sidebar-theme-card-active]="selectedThemeId() === theme.id"
          [attr.aria-pressed]="selectedThemeId() === theme.id"
          (click)="selectTheme(theme.id)"
        >
          <div class="sidebar-theme-card-copy">
            <span class="sidebar-theme-card-title">{{ theme.label }}</span>
            <span class="sidebar-theme-card-description">{{ theme.description }}</span>
          </div>

          <div class="sidebar-theme-card-scale" aria-hidden="true">
            @for (stop of previewStops; track stop) {
              <span
                class="sidebar-theme-card-stop"
                [style.background]="theme.themes.light.primary[stop]"
              ></span>
            }
          </div>
        </button>
      }
    </div>
  </div>
</p-popover>
